import type { ActionReturn } from "svelte/action";

interface ScrollSpyOptions {
	readonly sections: readonly { readonly id: string }[];
	setActiveId(this: void, id: string): void;
}

export function initScrollSpy(node: HTMLElement, options: ScrollSpyOptions): ActionReturn {
	const { sections, setActiveId } = options;
	const headings = sections.map((s) => node.querySelector(`#${s.id}`)).filter(Boolean) as HTMLElement[];
	const headerOffset = 130;
	const bottomThreshold = 300;

	function onScroll(): void {
		let current: string = sections[0]?.id ?? "";

		for (const heading of headings) {
			if (heading.getBoundingClientRect().top <= headerOffset) {
				current = heading.id;
			}
		}

		const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
		const lastHeading = headings.at(-1);
		const isNearBottom = scrollTop + clientHeight >= scrollHeight - bottomThreshold;
		const isLastSectionVisible = lastHeading !== undefined && lastHeading.getBoundingClientRect().top <= clientHeight;

		if (isNearBottom && isLastSectionVisible) {
			current = sections.at(-1)?.id ?? current;
		}

		setActiveId(current);
	}

	window.addEventListener("scroll", onScroll, { passive: true });
	onScroll();

	return {
		destroy(): void {
			window.removeEventListener("scroll", onScroll);
		},
	};
}
